import {
  Checkbox,
  FormControlLabel,
  Grid,
  InputAdornment,
  Paper,
  TextField,
} from "@material-ui/core";
import { DateTimePicker } from "@material-ui/pickers";
import { Moment } from "moment";
import React, { useEffect, useState } from "react";
import { useStressEntryContext } from "./StressEntryContext";
import { STRESSOR_CHECK_OUT_MODE } from "./constants";

export const ThermalCycleFields = ({ UnitVersion }: any) => {
  const [formData, setFormData] = useState({
    Calibration_date: null as Moment | null,
    Test_duration: "",
    test_condition: UnitVersion === "v12" ? "85" : "",
    Voltage_is_normal: false,
    Number_of_TestCycles: UnitVersion === "v12" ? "200" : "",
    Weights: UnitVersion === "v12" ? "500" : "",
  });

  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const { state, dispatch } = useStressEntryContext();

  const handleDateChange = (date: Moment | null) => {
    setFormData((prev) => ({ ...prev, Calibration_date: date }));
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === "test_condition") {
      const temp = parseFloat(value);
      if (isNaN(temp) || temp < -40 || temp > 85) {
        setErrors((prev) => ({
          ...prev,
          test_condition: "Value must be between -40°C and 85°C",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          test_condition: "",
        }));
      }
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: checked }));
  };

  useEffect(() => {
    if (UnitVersion === "v12") {
      setFormData((prev) => ({
        ...prev,
        Weights: prev.Weights || "500", // don't override user input
        test_condition: prev.test_condition || "85",
        Number_of_TestCycles: prev.Number_of_TestCycles || "200",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        Weights: "", // reset when not v12,
        test_condition: "",
        Number_of_TestCycles: "",
      }));
    }
  }, [UnitVersion]);

  useEffect(() => {
    const payload = {
      Calibration_date: formData.Calibration_date
        ? formData.Calibration_date.format("YYYY-MM-DD")
        : null,
      Test_duration: formData.Test_duration
        ? parseFloat(formData.Test_duration)
        : null,
      Test_condition: formData.test_condition ? formData.test_condition : null,
      Voltage_is_normal: formData.Voltage_is_normal,
      NumberofCycles: formData.Number_of_TestCycles
        ? parseFloat(formData.Number_of_TestCycles)
        : null,
      weight:
        UnitVersion === "v12"
          ? formData.Weights
            ? parseFloat(formData.Weights)
            : 500
          : null,
    };
    dispatch({ type: "TC_STRESS_DETAILS", payload });
  }, [formData, dispatch, UnitVersion]);

  return (
    <div>
      {state.mode === STRESSOR_CHECK_OUT_MODE &&
        state.isThermalCyclingCheck && (
          <Paper elevation={3} style={{ padding: 10, marginBottom: 16 }}>
            <Grid
              container
              direction="row"
              justifyContent="space-around"
              alignItems="flex-start"
              spacing={2}
              style={{ marginTop: 16, marginBottom: 16 }}
            >
              <Grid item xs={6}>
                <Grid container spacing={2}>
                  <Grid item xs={12} style={{ marginTop: 18 }}>
                    <DateTimePicker
                      label="Calibration Date"
                      format="YYYY-MM-DD HH:mm"
                      fullWidth
                      value={formData.Calibration_date}
                      onChange={handleDateChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      name="Test_duration"
                      label="Test duration"
                      type="number"
                      value={formData.Test_duration}
                      onChange={handleChange}
                      fullWidth
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">hours</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      name="test_condition"
                      label="Test Condition"
                      value={formData.test_condition}
                      onChange={handleChange}
                      fullWidth
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">°C</InputAdornment>
                        ),
                      }}
                      error={!!errors.test_condition}
                      helperText={errors.test_condition}
                    />
                  </Grid>

                  {UnitVersion && UnitVersion === "v12" && (
                    <Grid item xs={12}>
                      <TextField
                        name="Weights"
                        label="Weights"
                        type="number"
                        required
                        value={formData.Weights}
                        onChange={handleChange}
                        fullWidth
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">g</InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="Voltage_is_normal"
                          checked={formData.Voltage_is_normal}
                          onChange={handleCheckboxChange}
                        />
                      }
                      label="DUT circuit check normal"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      name="Number_of_TestCycles"
                      label="Number of TestCycles"
                      required
                      type="number"
                      value={formData.Number_of_TestCycles}
                      onChange={handleChange}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        )}
    </div>
  );
};
